import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getStripe } from '../utils/stripe';

function Subscribe() {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuthStatus } = useAuth();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const sessionId = query.get('session_id');
    
    if (sessionId) {
      // First try registration verification
      verifyRegistration(sessionId);
    }
  }, [location]);

  const verifyRegistration = async (sessionId) => {
    try {
      console.log('Verifying registration with session ID:', sessionId);
      const response = await fetch('/api/payment/verify-registration', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sessionId }),
      });

      const data = await response.json();
      console.log('Verification response:', data);

      if (response.ok && data.success) {
        await checkAuthStatus(); // Update auth context
        navigate('/dashboard');
      } else {
        // If registration verification fails, try regular subscription verification
        await verifySubscription(sessionId);
      }
    } catch (error) {
      console.error('Error verifying registration:', error);
    }
  };

  const verifySubscription = async (sessionId) => {
    try {
      console.log('Verifying subscription with session ID:', sessionId);
      const response = await fetch('/api/payment/verify-subscription', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sessionId }),
      });

      const data = await response.json();
      console.log('Verification response:', data);

      if (response.ok && data.success) {
        await checkAuthStatus(); // Update auth context
        navigate('/dashboard');
      } else {
        console.error('Subscription verification failed:', data.message);
      }
    } catch (error) {
      console.error('Error verifying subscription:', error);
    }
  };

  const handleSubscribe = async () => {
    try {
      const response = await fetch('/api/payment/create-checkout-session', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      
      if (data.sessionId) {
        const stripe = await getStripe();
        await stripe.redirectToCheckout({
          sessionId: data.sessionId,
        });
      }
    } catch (error) {
      console.error('Subscription error:', error);
    }
  };

  return (
    <div className="subscribe-container">
      <div className="subscribe-box">
        <h2>Subscribe to Card Profit Optimizer</h2>
        <p>Get access to all features with our premium subscription.</p>
        <button onClick={handleSubscribe} className="subscribe-button">
          Subscribe Now
        </button>
      </div>
    </div>
  );
}

export default Subscribe; 
